
import { defineComponent } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import HeaderBar from '@/components/common/HeaderBar.vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'Home',
  components: {
    BaseLayout,
    HeaderBar,
  },
  setup() {
    const router = useRouter();
    const mainCitiesArray = [
      {
        name: '臺北市',
        value: 'Taipei'
      },
      {
        name: '臺中市',
        value: 'Taichung'
      },
      {
        name: '高雄市',
        value: 'Kaohsiung'
      },
      {
        name: '臺南市',
        value: 'Tainan'
      },
      {
        name: '新竹市',
        value: 'Hsinchu'
      },
    ]
    const selectCity = (city: string) => {
      router.push(`/find-bus-route/${city}`);
    };
    const selectOther = () => {
      router.push('/other-city')
    }
    return {
      selectCity,
    }
  }
});
